import { render, staticRenderFns } from "./CompilatoreQuestionario.vue?vue&type=template&id=506bc2f2&scoped=true"
import script from "./CompilatoreQuestionario.vue?vue&type=script&lang=js"
export * from "./CompilatoreQuestionario.vue?vue&type=script&lang=js"
import style0 from "./CompilatoreQuestionario.vue?vue&type=style&index=0&id=506bc2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bc2f2",
  null
  
)

export default component.exports